import { SW_ANALYSIS_TYPE_MAP } from '@demandproai/shared';
import XModal from './XModal';
import XSelect from './XSelect';
import RenderIf from '../render-if/Renderif';
import SilentWitnessImageGroup from './SilentWitnessImageGroup';
import SilentWitnessFileGroup from './SilentWitnessFileGroup';
import SilentWitnessTextGroup from './SilentWitnessTextGroup';
import SilentWitnessOccupantsSection from './SilentWitnessOccupantsSection';
import { useSilentWitnessContext } from '../../contexts/SilentWitnessContext';
import { silentWitnessClasses } from './silentWitnessClasses';
import { cn } from "../../utils/classNames";
import XButton from './XButton';

const ANALYSIS_TYPE_OPTIONS = Object.values(SW_ANALYSIS_TYPE_MAP);

const analysisTypeSectionClasses = "mb-4";
const analysisTypeHeaderClasses = 'mb-2 pb-2';
const groupTitleClasses = 'mb-3 pb-2';
const analysisTypeGridClasses = "grid grid-cols-12 gap-4";
const analysisTypeSelectWrapperClasses = "col-span-12 md:col-span-6";
const noItemsTextClasses = "text-body text-base";
const noItemsWrapperClasses = "text-center py-5";

const SilentWitnessModal = () => {
  const {
    closeSilentWitnessModal,
    getLiabilityGroups,
    handleSubmit,
    generateSilentWitnessReportIsLoading,
    analysisType,
    setAnalysisType,
    latestSilentWitnessReportId,
    handleRemoveReport,
    removeSilentWitnessReportIsLoading,
  } = useSilentWitnessContext();

  const liabilityGroups = getLiabilityGroups();
  const hasItems = liabilityGroups.length > 0;

  return (
    <XModal
      isOpen={true}
      title="Silent Witness"
      subtitle="Select liability documents to generate Silent Witness report"
      onClose={closeSilentWitnessModal}
      onSubmit={handleSubmit}
      submitText="Submit"
      isSubmitting={generateSilentWitnessReportIsLoading || removeSilentWitnessReportIsLoading}
      size="lg"
      footerAction={
        <RenderIf shouldRender={Boolean(latestSilentWitnessReportId)}>
          <XButton
            variant="outline"
            buttonText="Remove Report"
            loadingText="Removing..."
            loading={removeSilentWitnessReportIsLoading}
            onClick={handleRemoveReport}
          />
        </RenderIf>
      }
    >
      <div className={analysisTypeSectionClasses}>
        <h6 className={cn(analysisTypeHeaderClasses, silentWitnessClasses.groupHeader)}>Analysis type</h6>
        <div className={analysisTypeGridClasses}>
          <div className={analysisTypeSelectWrapperClasses}>
            <XSelect
              value={analysisType}
              emptyOption={false}
              options={ANALYSIS_TYPE_OPTIONS}
              onChange={(event) => setAnalysisType(event.target.value)}
            />
          </div>
        </div>
      </div>

      <SilentWitnessOccupantsSection />

      <RenderIf shouldRender={!hasItems}>
        <div className={noItemsWrapperClasses}>
          <p className={noItemsTextClasses}>No liability documents available</p>
        </div>
      </RenderIf>

      <RenderIf shouldRender={hasItems}>
        {liabilityGroups.map((group) => (
          <div key={group.key} className={analysisTypeSectionClasses}>
            <h6 className={cn(groupTitleClasses, silentWitnessClasses.groupHeader)}>
              {group.title}
            </h6>

            {group.type === 'image' && (
              <SilentWitnessImageGroup group={group} />
            )}

            {group.type === 'file' && (
              <SilentWitnessFileGroup group={group} />
            )}

            {group.type === 'text' && (
              <SilentWitnessTextGroup group={group} />
            )}
          </div>
        ))}
      </RenderIf>

    </XModal>
  );
};

export default SilentWitnessModal;
